export enum ProductFieldInfoVisibility {
    "REQ","OPT","SUP_OPT","NOT_ALL"
}